import React from 'react'
import { CertificadoAtencionCard } from './CertificadoAtencionCard'
import { CertificadoAtencionDetalleOrdenInformacion } from './CertificadoAtencionDetalleOrdenInformacion'

export const CertificadoAtencionDetalleOrden = (props) => {

    const { idObraSocial } = props;

    console.log("idObraSocial", idObraSocial)
    return (
        <CertificadoAtencionCard width={"75%"}>
            <CertificadoAtencionDetalleOrdenInformacion
                idObraSocial={idObraSocial}
            />
        </CertificadoAtencionCard>
    )
}
